var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon5",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "coins",
    transform: "translate(489 885.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56298",
    "data-name": "\\uADF8\\uB8F9 56298",
    transform: "translate(7.993 13.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56282",
    "data-name": "\\uADF8\\uB8F9 56282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56281",
    "data-name": "\\uADF8\\uB8F9 56281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56275",
    "data-name": "\\uADF8\\uB8F9 56275",
    transform: "translate(2.245 1.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33590",
    "data-name": "\\uD328\\uC2A4 33590",
    d: "M30.963,24.65l0,2.559a3.8,3.8,0,0,0-2.241-3.133,9.219,9.219,0,0,0-2.515-.964,11.918,11.918,0,0,0-8.22.964,3.775,3.775,0,0,0-2.2,3.088l.009-2.559a3.765,3.765,0,0,1,2.2-3.084,11.919,11.919,0,0,1,8.22-.968,9.421,9.421,0,0,1,2.514.964,3.8,3.8,0,0,1,2.237,3.133Z",
    transform: "translate(-15.781 -20.234)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56276",
    "data-name": "\\uADF8\\uB8F9 56276",
    transform: "translate(15.217 5.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33591",
    "data-name": "\\uD328\\uC2A4 33591",
    d: "M38.746,27.3l-.007,2.558a3.768,3.768,0,0,1-2.2,3.088l.007-2.558a3.768,3.768,0,0,0,2.2-3.088Z",
    transform: "translate(-36.536 -27.299)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56277",
    "data-name": "\\uADF8\\uB8F9 56277",
    transform: "translate(2.247 5.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33592",
    "data-name": "\\uD328\\uC2A4 33592",
    d: "M15.784,29.787l.007-2.558a3.794,3.794,0,0,0,2.236,3.13,11.844,11.844,0,0,0,10.734,0l-.007,2.558a11.844,11.844,0,0,1-10.734,0,3.794,3.794,0,0,1-2.236-3.13Z",
    transform: "translate(-15.784 -27.23)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56278",
    "data-name": "\\uADF8\\uB8F9 56278",
    transform: "translate(2.254 1.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33593",
    "data-name": "\\uD328\\uC2A4 33593",
    d: "M28.73,22.607c2.97,1.715,2.986,4.5.035,6.219a11.844,11.844,0,0,1-10.734,0c-2.968-1.713-2.983-4.5-.035-6.216a11.844,11.844,0,0,1,10.734,0Z",
    transform: "translate(-15.796 -21.322)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56279",
    "data-name": "\\uADF8\\uB8F9 56279",
    transform: "translate(0 5.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33594",
    "data-name": "\\uD328\\uC2A4 33594",
    d: "M31.861,27.276l-.007,2.558c0,1.449-.956,2.9-2.857,4a15.325,15.325,0,0,1-13.905,0c-1.938-1.119-2.906-2.588-2.9-4.055l.007-2.558c0,1.467.964,2.935,2.9,4.055a15.325,15.325,0,0,0,13.905,0c1.9-1.1,2.853-2.551,2.857-4Z",
    transform: "translate(-12.189 -27.219)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56280",
    "data-name": "\\uADF8\\uB8F9 56280",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33595",
    "data-name": "\\uD328\\uC2A4 33595",
    d: "M28.963,19.819c3.852,2.224,3.872,5.832.045,8.056a15.325,15.325,0,0,1-13.905,0c-3.852-2.224-3.872-5.829-.045-8.053a15.325,15.325,0,0,1,13.906,0ZM16.684,26.955a11.844,11.844,0,0,0,10.734,0c2.951-1.715,2.935-4.5-.035-6.219a11.844,11.844,0,0,0-10.734,0c-2.948,1.713-2.933,4.5.035,6.216",
    transform: "translate(-12.201 -18.152)",
    fill: "#fed44c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56297",
    "data-name": "\\uADF8\\uB8F9 56297",
    transform: "translate(5.746 3.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56296",
    "data-name": "\\uADF8\\uB8F9 56296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56283",
    "data-name": "\\uADF8\\uB8F9 56283",
    transform: "translate(7.378 0.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33596",
    "data-name": "\\uD328\\uC2A4 33596",
    d: "M33.6,24.442v.527l-.414.241v-.527Z",
    transform: "translate(-33.187 -24.442)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56284",
    "data-name": "\\uADF8\\uB8F9 56284",
    transform: "translate(4.269 0.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33597",
    "data-name": "\\uD328\\uC2A4 33597",
    d: "M28.213,25.821v-.527c0-.123.09-.235.268-.338a1.21,1.21,0,0,1,.664-.144,1.938,1.938,0,0,1,.791.207v.527a1.938,1.938,0,0,0-.791-.207,1.21,1.21,0,0,0-.664.144c-.177.1-.267.215-.268.338Z",
    transform: "translate(-28.213 -24.81)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56285",
    "data-name": "\\uADF8\\uB8F9 56285",
    transform: "translate(4.966 1.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33598",
    "data-name": "\\uD328\\uC2A4 33598",
    d: "M30.855,25.651v.527l-1.526.887v-.527Z",
    transform: "translate(-29.328 -25.651)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56286",
    "data-name": "\\uADF8\\uB8F9 56286",
    transform: "translate(6.492 1.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33599",
    "data-name": "\\uD328\\uC2A4 33599",
    d: "M32.47,26.6l0,.527a1.879,1.879,0,0,0-.7-.948v-.527A1.879,1.879,0,0,1,32.47,26.6Z",
    transform: "translate(-31.769 -25.651)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56287",
    "data-name": "\\uADF8\\uB8F9 56287",
    transform: "translate(7.19 2.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33600",
    "data-name": "\\uD328\\uC2A4 33600",
    d: "M34.168,26.965l0,.527-1.279.126v-.527Z",
    transform: "translate(-32.888 -26.965)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56288",
    "data-name": "\\uADF8\\uB8F9 56288",
    transform: "translate(2.805 1.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33601",
    "data-name": "\\uD328\\uC2A4 33601",
    d: "M25.871,25.982v-.527a.537.537,0,0,0,.007.087,2.258,2.258,0,0,0,.776,1.116v.527a2.258,2.258,0,0,1-.776-1.116A.539.539,0,0,1,25.871,25.982Z",
    transform: "translate(-25.871 -25.454)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56289",
    "data-name": "\\uADF8\\uB8F9 56289",
    transform: "translate(3.973 2.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33602",
    "data-name": "\\uD328\\uC2A4 33602",
    d: "M28.1,28.58l0,.527q0-.009,0-.019a1.142,1.142,0,0,0-.359-.569v-.527a1.142,1.142,0,0,1,.359.569Q28.1,28.571,28.1,28.58Z",
    transform: "translate(-27.739 -27.993)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56290",
    "data-name": "\\uADF8\\uB8F9 56290",
    transform: "translate(2.511 2.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33603",
    "data-name": "\\uD328\\uC2A4 33603",
    d: "M26.864,27.993v.527l-1.462.85v-.527Z",
    transform: "translate(-25.4 -27.993)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56291",
    "data-name": "\\uADF8\\uB8F9 56291",
    transform: "translate(0 2.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33604",
    "data-name": "\\uD328\\uC2A4 33604",
    d: "M22.509,28.664l0,.527a2.423,2.423,0,0,1-1.125-1.676v-.527A2.423,2.423,0,0,0,22.509,28.664Z",
    transform: "translate(-21.383 -26.988)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56292",
    "data-name": "\\uADF8\\uB8F9 56292",
    transform: "translate(0.532 4.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33605",
    "data-name": "\\uD328\\uC2A4 33605",
    d: "M22.76,30.523v.527l-.524-.3V30.22Z",
    transform: "translate(-22.234 -30.22)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56293",
    "data-name": "\\uADF8\\uB8F9 56293",
    transform: "translate(1.056 4.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33606",
    "data-name": "\\uD328\\uC2A4 33606",
    d: "M23.659,30.161v.527l-.585.34V30.5Z",
    transform: "translate(-23.073 -30.161)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56294",
    "data-name": "\\uADF8\\uB8F9 56294",
    transform: "translate(1.641 3.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33607",
    "data-name": "\\uD328\\uC2A4 33607",
    d: "M28.152,29.059v.527q0,.424-.647.8a3.041,3.041,0,0,1-1.665.381,4.25,4.25,0,0,1-1.83-.491v-.527a4.25,4.25,0,0,0,1.83.491,3.041,3.041,0,0,0,1.665-.381Q28.15,29.483,28.152,29.059Z",
    transform: "translate(-24.008 -29.059)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56295",
    "data-name": "\\uADF8\\uB8F9 56295",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33608",
    "data-name": "\\uD328\\uC2A4 33608",
    d: "M27.162,26.925q.071.472-.641.884a3.041,3.041,0,0,1-1.665.381,4.25,4.25,0,0,1-1.83-.491l-.585.34-.524-.3.593-.344a2.423,2.423,0,0,1-1.125-1.676l1.3-.067a1.807,1.807,0,0,0,.707,1.228l1.577-.917a2.258,2.258,0,0,1-.776-1.116q-.074-.456.631-.864A3.031,3.031,0,0,1,26.47,23.6a4.021,4.021,0,0,1,1.776.46l.406-.236.524.3-.414.241A2.6,2.6,0,0,1,29.855,25.7l-1.279.126a1.879,1.879,0,0,0-.7-.948l-1.526.887.025.014a2.238,2.238,0,0,1,.786,1.143Zm-2.417.5a1.23,1.23,0,0,0,.7-.142c.189-.11.281-.232.272-.366a1.142,1.142,0,0,0-.359-.569l-1.462.85a2.288,2.288,0,0,0,.849.226m1.227-2.041,1.4-.816a1.938,1.938,0,0,0-.791-.207,1.21,1.21,0,0,0-.664.144c-.18.1-.27.219-.268.344a1.038,1.038,0,0,0,.318.535",
    transform: "translate(-21.385 -23.596)",
    fill: "#fed44c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56322",
    "data-name": "\\uADF8\\uB8F9 56322",
    transform: "translate(8.869 9.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56306",
    "data-name": "\\uADF8\\uB8F9 56306",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56305",
    "data-name": "\\uADF8\\uB8F9 56305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56299",
    "data-name": "\\uADF8\\uB8F9 56299",
    transform: "translate(2.245 1.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33609",
    "data-name": "\\uD328\\uC2A4 33609",
    d: "M32.364,18.934l0,2.559a3.8,3.8,0,0,0-2.241-3.133A9.219,9.219,0,0,0,27.6,17.4a11.918,11.918,0,0,0-8.22.964,3.775,3.775,0,0,0-2.2,3.088l.009-2.559a3.765,3.765,0,0,1,2.2-3.084,11.919,11.919,0,0,1,8.22-.968,9.421,9.421,0,0,1,2.514.964,3.8,3.8,0,0,1,2.237,3.133Z",
    transform: "translate(-17.183 -14.517)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56300",
    "data-name": "\\uADF8\\uB8F9 56300",
    transform: "translate(15.217 5.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33610",
    "data-name": "\\uD328\\uC2A4 33610",
    d: "M40.147,21.583l-.007,2.558a3.768,3.768,0,0,1-2.2,3.088l.007-2.558a3.768,3.768,0,0,0,2.2-3.088Z",
    transform: "translate(-37.937 -21.583)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56301",
    "data-name": "\\uADF8\\uB8F9 56301",
    transform: "translate(2.247 5.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33611",
    "data-name": "\\uD328\\uC2A4 33611",
    d: "M17.185,24.071l.007-2.558a3.794,3.794,0,0,0,2.236,3.13,11.844,11.844,0,0,0,10.734,0L30.155,27.2a11.844,11.844,0,0,1-10.734,0A3.794,3.794,0,0,1,17.185,24.071Z",
    transform: "translate(-17.185 -21.513)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56302",
    "data-name": "\\uADF8\\uB8F9 56302",
    transform: "translate(2.254 1.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33612",
    "data-name": "\\uD328\\uC2A4 33612",
    d: "M30.132,16.891c2.97,1.715,2.986,4.5.035,6.219a11.844,11.844,0,0,1-10.734,0c-2.968-1.713-2.983-4.5-.035-6.216a11.844,11.844,0,0,1,10.734,0Z",
    transform: "translate(-17.197 -15.606)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56303",
    "data-name": "\\uADF8\\uB8F9 56303",
    transform: "translate(0 5.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33613",
    "data-name": "\\uD328\\uC2A4 33613",
    d: "M33.262,21.559l-.007,2.558c0,1.449-.956,2.9-2.857,4a15.325,15.325,0,0,1-13.905,0c-1.938-1.119-2.906-2.588-2.9-4.055L13.6,21.5c0,1.467.964,2.935,2.9,4.055a15.325,15.325,0,0,0,13.905,0c1.9-1.1,2.853-2.551,2.857-4Z",
    transform: "translate(-13.59 -21.503)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56304",
    "data-name": "\\uADF8\\uB8F9 56304",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33614",
    "data-name": "\\uD328\\uC2A4 33614",
    d: "M30.364,14.1c3.852,2.224,3.872,5.832.045,8.056a15.325,15.325,0,0,1-13.905,0c-3.852-2.224-3.872-5.829-.045-8.053a15.326,15.326,0,0,1,13.906,0ZM18.085,21.239a11.844,11.844,0,0,0,10.734,0c2.951-1.715,2.935-4.5-.035-6.219a11.844,11.844,0,0,0-10.734,0c-2.948,1.713-2.933,4.5.035,6.216",
    transform: "translate(-13.602 -12.436)",
    fill: "#fed44c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56321",
    "data-name": "\\uADF8\\uB8F9 56321",
    transform: "translate(5.746 3.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56320",
    "data-name": "\\uADF8\\uB8F9 56320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56307",
    "data-name": "\\uADF8\\uB8F9 56307",
    transform: "translate(7.378 0.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33615",
    "data-name": "\\uD328\\uC2A4 33615",
    d: "M35,18.726v.527l-.414.241v-.527Z",
    transform: "translate(-34.588 -18.726)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56308",
    "data-name": "\\uADF8\\uB8F9 56308",
    transform: "translate(4.269 0.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33616",
    "data-name": "\\uD328\\uC2A4 33616",
    d: "M29.614,20.1v-.527c0-.123.09-.235.268-.338a1.21,1.21,0,0,1,.664-.144,1.938,1.938,0,0,1,.791.207l0,.527a1.938,1.938,0,0,0-.791-.207,1.21,1.21,0,0,0-.664.144c-.177.1-.267.215-.268.338Z",
    transform: "translate(-29.614 -19.094)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56309",
    "data-name": "\\uADF8\\uB8F9 56309",
    transform: "translate(4.966 1.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33617",
    "data-name": "\\uD328\\uC2A4 33617",
    d: "M32.257,19.935v.527l-1.526.887v-.527Z",
    transform: "translate(-30.729 -19.935)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56310",
    "data-name": "\\uADF8\\uB8F9 56310",
    transform: "translate(6.492 1.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33618",
    "data-name": "\\uD328\\uC2A4 33618",
    d: "M33.871,20.883v.527a1.879,1.879,0,0,0-.7-.948v-.527A1.879,1.879,0,0,1,33.871,20.883Z",
    transform: "translate(-33.171 -19.935)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56311",
    "data-name": "\\uADF8\\uB8F9 56311",
    transform: "translate(7.191 2.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33619",
    "data-name": "\\uD328\\uC2A4 33619",
    d: "M35.57,21.249v.527l-1.279.126v-.527Z",
    transform: "translate(-34.289 -21.249)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56312",
    "data-name": "\\uADF8\\uB8F9 56312",
    transform: "translate(2.805 1.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33620",
    "data-name": "\\uD328\\uC2A4 33620",
    d: "M27.272,20.265v-.527a.537.537,0,0,0,.007.087,2.258,2.258,0,0,0,.776,1.116v.527a2.258,2.258,0,0,1-.776-1.116A.538.538,0,0,1,27.272,20.265Z",
    transform: "translate(-27.272 -19.738)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56313",
    "data-name": "\\uADF8\\uB8F9 56313",
    transform: "translate(3.973 2.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33621",
    "data-name": "\\uD328\\uC2A4 33621",
    d: "M29.5,22.864v.527q0-.009,0-.019a1.142,1.142,0,0,0-.359-.569v-.527a1.142,1.142,0,0,1,.359.569q0,.009,0,.019Z",
    transform: "translate(-29.141 -22.277)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56314",
    "data-name": "\\uADF8\\uB8F9 56314",
    transform: "translate(2.511 2.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33622",
    "data-name": "\\uD328\\uC2A4 33622",
    d: "M28.265,22.277V22.8l-1.462.85v-.527Z",
    transform: "translate(-26.801 -22.277)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56315",
    "data-name": "\\uADF8\\uB8F9 56315",
    transform: "translate(0 2.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33623",
    "data-name": "\\uD328\\uC2A4 33623",
    d: "M23.91,22.948v.527A2.423,2.423,0,0,1,22.784,21.8v-.527A2.423,2.423,0,0,0,23.91,22.948Z",
    transform: "translate(-22.784 -21.272)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56316",
    "data-name": "\\uADF8\\uB8F9 56316",
    transform: "translate(0.532 4.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33624",
    "data-name": "\\uD328\\uC2A4 33624",
    d: "M24.161,24.807v.527l-.524-.3V24.5Z",
    transform: "translate(-23.635 -24.504)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56317",
    "data-name": "\\uADF8\\uB8F9 56317",
    transform: "translate(1.056 4.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33625",
    "data-name": "\\uD328\\uC2A4 33625",
    d: "M25.06,24.445v.527l-.585.34,0-.527Z",
    transform: "translate(-24.474 -24.445)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56318",
    "data-name": "\\uADF8\\uB8F9 56318",
    transform: "translate(1.641 3.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33626",
    "data-name": "\\uD328\\uC2A4 33626",
    d: "M29.553,23.343v.527q0,.424-.647.8a3.041,3.041,0,0,1-1.665.381,4.25,4.25,0,0,1-1.83-.491v-.527a4.25,4.25,0,0,0,1.83.491,3.041,3.041,0,0,0,1.665-.381Q29.551,23.766,29.553,23.343Z",
    transform: "translate(-25.41 -23.343)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56319",
    "data-name": "\\uADF8\\uB8F9 56319",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33627",
    "data-name": "\\uD328\\uC2A4 33627",
    d: "M28.563,21.209q.071.472-.641.884a3.041,3.041,0,0,1-1.665.381,4.25,4.25,0,0,1-1.83-.491l-.585.34-.524-.3.593-.344A2.423,2.423,0,0,1,22.786,20l1.3-.067a1.807,1.807,0,0,0,.707,1.228l1.577-.917a2.258,2.258,0,0,1-.776-1.116q-.074-.456.631-.864a3.03,3.03,0,0,1,1.642-.383,4.021,4.021,0,0,1,1.776.46l.406-.236.524.3-.414.241a2.6,2.6,0,0,1,1.092,1.336l-1.279.126a1.879,1.879,0,0,0-.7-.948l-1.526.887.025.014A2.238,2.238,0,0,1,28.563,21.209Zm-2.417.5a1.23,1.23,0,0,0,.7-.142c.189-.11.281-.232.272-.366a1.142,1.142,0,0,0-.359-.569l-1.462.85a2.288,2.288,0,0,0,.849.226m1.227-2.041,1.4-.816a1.938,1.938,0,0,0-.791-.207,1.21,1.21,0,0,0-.664.144c-.18.1-.27.219-.268.344a1.038,1.038,0,0,0,.318.535",
    transform: "translate(-22.786 -17.88)",
    fill: "#fed44c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56346",
    "data-name": "\\uADF8\\uB8F9 56346",
    transform: "translate(11.328 5.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56330",
    "data-name": "\\uADF8\\uB8F9 56330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56329",
    "data-name": "\\uADF8\\uB8F9 56329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56323",
    "data-name": "\\uADF8\\uB8F9 56323",
    transform: "translate(2.245 1.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33628",
    "data-name": "\\uD328\\uC2A4 33628",
    d: "M36.3,12.058l0,2.559a3.8,3.8,0,0,0-2.241-3.133,9.219,9.219,0,0,0-2.514-.964,11.918,11.918,0,0,0-8.22.964,3.775,3.775,0,0,0-2.2,3.088l.009-2.559a3.765,3.765,0,0,1,2.2-3.084,11.919,11.919,0,0,1,8.22-.968,9.421,9.421,0,0,1,2.514.964A3.8,3.8,0,0,1,36.3,12.058Z",
    transform: "translate(-21.117 -7.642)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56324",
    "data-name": "\\uADF8\\uB8F9 56324",
    transform: "translate(15.217 5.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33629",
    "data-name": "\\uD328\\uC2A4 33629",
    d: "M44.082,14.708l-.007,2.558a3.768,3.768,0,0,1-2.2,3.088l.007-2.558A3.768,3.768,0,0,0,44.082,14.708Z",
    transform: "translate(-41.871 -14.708)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56325",
    "data-name": "\\uADF8\\uB8F9 56325",
    transform: "translate(2.247 5.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33630",
    "data-name": "\\uD328\\uC2A4 33630",
    d: "M21.12,17.2l.007-2.558a3.794,3.794,0,0,0,2.236,3.13,11.844,11.844,0,0,0,10.734,0l-.007,2.558a11.844,11.844,0,0,1-10.734,0A3.794,3.794,0,0,1,21.12,17.2Z",
    transform: "translate(-21.12 -14.638)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56326",
    "data-name": "\\uADF8\\uB8F9 56326",
    transform: "translate(2.254 1.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33631",
    "data-name": "\\uD328\\uC2A4 33631",
    d: "M34.066,10.016c2.97,1.715,2.986,4.5.035,6.219a11.844,11.844,0,0,1-10.734,0c-2.968-1.713-2.983-4.5-.035-6.216a11.844,11.844,0,0,1,10.734,0Z",
    transform: "translate(-21.132 -8.731)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56327",
    "data-name": "\\uADF8\\uB8F9 56327",
    transform: "translate(0 5.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33632",
    "data-name": "\\uD328\\uC2A4 33632",
    d: "M37.2,14.684l-.007,2.558c0,1.449-.956,2.9-2.857,4a15.325,15.325,0,0,1-13.905,0c-1.938-1.119-2.906-2.588-2.9-4.055l.007-2.558c0,1.467.964,2.935,2.9,4.055a15.325,15.325,0,0,0,13.905,0C36.241,17.579,37.193,16.133,37.2,14.684Z",
    transform: "translate(-17.525 -14.628)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56328",
    "data-name": "\\uADF8\\uB8F9 56328",
    transform: "translate(0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33633",
    "data-name": "\\uD328\\uC2A4 33633",
    d: "M34.3,7.228c3.852,2.224,3.872,5.832.045,8.056a15.325,15.325,0,0,1-13.905,0c-3.852-2.224-3.872-5.829-.045-8.053a15.326,15.326,0,0,1,13.906,0ZM22.019,14.364a11.844,11.844,0,0,0,10.734,0c2.951-1.715,2.935-4.5-.035-6.219a11.844,11.844,0,0,0-10.734,0c-2.948,1.713-2.933,4.5.035,6.216",
    transform: "translate(-17.536 -5.561)",
    fill: "#fed44c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56375",
    "data-name": "\\uADF8\\uB8F9 56375",
    transform: "translate(1 7.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56373",
    "data-name": "\\uADF8\\uB8F9 56373",
    transform: "translate(0 1.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56354",
    "data-name": "\\uADF8\\uB8F9 56354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56353",
    "data-name": "\\uADF8\\uB8F9 56353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56347",
    "data-name": "\\uADF8\\uB8F9 56347",
    transform: "translate(1.826 1.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33647",
    "data-name": "\\uD328\\uC2A4 33647",
    d: "M17.014,28.346,14.478,29.8a3.361,3.361,0,0,1-1.991.394,5.232,5.232,0,0,1-1.523-.384,7.011,7.011,0,0,1-.88-.43A13.305,13.305,0,0,1,3.921,18.9v-.141a5.623,5.623,0,0,1,.494-2.3,3.7,3.7,0,0,1,.468-.738A3.06,3.06,0,0,1,5.727,15l2.536-1.445a2.977,2.977,0,0,0-.844.718,3.312,3.312,0,0,0-.463.733,5.48,5.48,0,0,0-.494,2.3c0,.045-.005.091-.005.142a13.314,13.314,0,0,0,6.163,10.481,7.85,7.85,0,0,0,.885.425,5.345,5.345,0,0,0,1.518.389,3.36,3.36,0,0,0,1.991-.4Z",
    transform: "translate(-3.921 -13.559)",
    fill: "#fed44c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56348",
    "data-name": "\\uADF8\\uB8F9 56348",
    transform: "translate(12.382 12.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33648",
    "data-name": "\\uD328\\uC2A4 33648",
    d: "M23.35,35.272l-2.538,1.475c1.11-.645,1.8-2.015,1.8-3.959l2.538-1.475C25.148,33.258,24.459,34.627,23.35,35.272Z",
    transform: "translate(-20.811 -31.313)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56349",
    "data-name": "\\uADF8\\uB8F9 56349",
    transform: "translate(3.631 0.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33649",
    "data-name": "\\uD328\\uC2A4 33649",
    d: "M6.81,14.78l2.538-1.475c1.125-.654,2.681-.563,4.4.428l-2.538,1.475C9.491,14.217,7.935,14.127,6.81,14.78Z",
    transform: "translate(-6.81 -12.887)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56350",
    "data-name": "\\uADF8\\uB8F9 56350",
    transform: "translate(8.028 1.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33650",
    "data-name": "\\uD328\\uC2A4 33650",
    d: "M13.845,15.716l2.538-1.475a13.6,13.6,0,0,1,6.158,10.67L20,26.386a13.6,13.6,0,0,0-6.158-10.67Z",
    transform: "translate(-13.845 -14.241)",
    fill: "#f9c73a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56351",
    "data-name": "\\uADF8\\uB8F9 56351",
    transform: "translate(2.425 1.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33651",
    "data-name": "\\uD328\\uC2A4 33651",
    d: "M11.082,15.344A13.292,13.292,0,0,1,17.24,25.814c-.011,3.84-2.792,5.4-6.2,3.466A13.292,13.292,0,0,1,4.88,18.812c.011-3.844,2.792-5.4,6.2-3.468Z",
    transform: "translate(-4.88 -14.514)",
    fill: "#f2bc36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56352",
    "data-name": "\\uADF8\\uB8F9 56352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33652",
    "data-name": "\\uD328\\uC2A4 33652",
    d: "M9.034,12.568c4.421,2.515,7.993,8.616,7.979,13.623S13.4,33.216,8.982,30.7.986,22.086,1,17.08s3.613-7.027,8.034-4.512ZM8.988,28.633c3.406,1.938,6.187.376,6.2-3.481A13.36,13.36,0,0,0,9.028,14.636c-3.409-1.94-6.191-.378-6.2,3.483A13.36,13.36,0,0,0,8.988,28.633",
    transform: "translate(-1 -11.486)",
    fill: "#f9c73a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56374",
    "data-name": "\\uADF8\\uB8F9 56374",
    transform: "translate(2.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33669",
    "data-name": "\\uD328\\uC2A4 33669",
    d: "M20.956,23.84c-.01,2.491-.9,4.241-2.336,5.063l-2.541,1.456c1.44-.827,2.331-2.577,2.336-5.063.015-5.012-3.555-11.115-7.979-13.632C8.212,10.4,6.2,10.279,4.74,11.111L7.276,9.66c1.456-.837,3.473-.72,5.7.548,4.419,2.516,7.99,8.619,7.979,13.632Z",
    transform: "translate(-4.74 -9.125)",
    fill: "#fed44c"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon5);
export default __webpack_public_path__ + "static/media/sec2Icon5.39d997688acfd9c81188446acf74411c.svg";
export { ForwardRef as ReactComponent };